// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.rpc.auth

import org.multipaz.cbor.DataItem
import org.multipaz.rpc.handler.RpcDispatcher
import org.multipaz.rpc.handler.RpcNotifier
import org.multipaz.rpc.handler.RpcReturnCode
import org.multipaz.cbor.Bstr
import org.multipaz.rpc.auth.ClientCheck
import org.multipaz.rpc.client.RpcStub
import org.multipaz.cbor.Tstr
import org.multipaz.cbor.buildCborArray
import org.multipaz.cbor.Cbor


class ClientCheckStub(
    endpoint: String,
    dispatcher: RpcDispatcher,
    notifier: RpcNotifier,
    state: DataItem = Bstr(byteArrayOf())
): RpcStub(endpoint, dispatcher, notifier, state), ClientCheck {

    override suspend fun ping(message: String): String {
        val rpcState = this.rpcState
        val rpcParameters = buildCborArray {
            add(rpcState)
            add(Tstr(message))
        }
        val rpcResponse = rpcDispatcher.dispatch(rpcEndpoint, "ping", rpcParameters)
        this.rpcState = rpcResponse[0]
        if (rpcResponse[2].asNumber.toInt() != RpcReturnCode.RESULT.ordinal) {
            this.rpcDispatcher.exceptionMap.handleExceptionReturn(rpcResponse)
        }
        return rpcResponse[3].asTstr
    }

    companion object {
        fun fromDataItem(
            data: DataItem,
            dispatcher: RpcDispatcher,
            notifier: RpcNotifier,
        ): ClientCheckStub {
            val endpoint = data["endpoint"].asTstr
            val state = data["state"]
            return ClientCheckStub(endpoint, dispatcher, notifier, state)
        }

        fun fromCbor(
            data: ByteArray,
            dispatcher: RpcDispatcher,
            notifier: RpcNotifier,
        ): ClientCheckStub {
            val dataItem = Cbor.decode(data)
            return fromDataItem(dataItem, dispatcher, notifier)
        }
    }
}
